import { useNode, useEditor } from '@craftjs/core'
import { CustomCodeSettings } from './CustomCodeSettings'

import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'


export const defaultProps = {
  code: '<p>Hello world!</p>',
}

export const dynamicProps = ['code']

export const CustomCode = withBlock(
  props => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { code } = blockProps

    const _ = props.renderValue

    return (
      <div ref={ref => props.retRef(ref)} className={'block-custom-code custom-content ' + props.className}>
        <div dangerouslySetInnerHTML={{ __html: _(code) }}></div>
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

CustomCode.craft = withCraft({
  name: 'CustomCode',
  defaultProps: defaultProps,
  settings: CustomCodeSettings,
})
